import React, { useState, useEffect } from "react";
import { Box, Button, Divider, Chip } from "@mui/material";
import AvailableJob from "./subTable/AvailableJob";
import AllBatch from "./subTable/AllBatch";
import Completed from "./subTable/Completed";
import Accepted from "./subTable/Accepted";
import Incomplete from "./subTable/Incomplete";
import NotAccepted from "./subTable/NotAccepted";
import axios from "axios";
import { useParams } from "react-router-dom";
import ModalToCreateJobBatches from "../ModalToCreateJobBatches";
import { Snackbar, Alert } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";

const JobsActionPanel = ({
  isDisabled,
  campaignData,
  // openModalToCreateJobBatches,
  // setOpenModalToCreateJobBatches,
}) => {
  const { id } = useParams();
  const [availableJobs, setAvailableJobs] = React.useState([]);
  const [availableBatches, setAvailableBatches] = React.useState([]);
  const [acceptedBatches, setAcceptedBatches] = useState([]);
  const [openModalToCreateJobBatches, setOpenModalToCreateJobBatches] =
    useState(false);
  const serviceName = "Installation";
  const serviceType = 1;
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });
  const [selectedBatchIds, setSelectedBatchIds] = React.useState([]);
  const [allPublish, setAllPublish] = React.useState(false);
  const [isPublishDisabled, setIsPublishDisabled] = useState(false);
  const [openModalToUpdateBatch, setOpenModalToUpdateBatch] = useState(false);
  const [selectedBatch, setSelectedBatch] = useState(null);
  const [isAllBatchesLoading, setAllBatchesLoading] = useState(false);
  const [allJobsBasedLoading, setAllJobsBasedLoading] = useState(false);

  const filters = [
    "Available Jobs",
    "All Batches",
    "Incomplete",
    "Not Accepted",
    "Accepted",
    "Completed",
  ];

  const actions = [
    // "Create Lots Manually",
    "Create Batches",
    // "Publish All Batches",
    // "Create Jobs",
    "Publish All Batches",
  ];

  const [selectedFilter, setSelectedFilter] = useState("Available Jobs");
  const [activeTable, setActiveTable] = useState("Available Jobs");
  const [totalBatches, setTotalBatches] = useState(0);
  const [totalCompletedBatches, setTotalCompletedBatches] = useState(0);
  const [completedBatches, setCompletedBatches] = useState([]);
  const [totalAcceptedBatches, setTotalAcceptedBatches] = useState(0);
  const [totalNotAcceptedBatches, setTotalNotAcceptedBatches] = useState(0);
  const [totalIncompleteBatches, setTotalIncompleteBatches] = useState(0);
  const [incompleteBatches, setIncompleteBatches] = useState([]);
  const [forbatch, setForBatch] = useState([]);
  const [selectedJobs, setSelectedJobs] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [isNotAccepted, setIsNotAccepted] = useState([]);

  const fetchDataBasedOnFilter = async (filter) => {
    if (filter === "Available Jobs") {
      await fetchAllJobsBasedOnCampaignId();
    } else if (filter === "All Batches") {
      await fetchAllBatchesBasedOnCampaignId();
    } else if (filter === "Incomplete") {
      await fetchIncompleteBatches();
    } else if (filter === "Not Accepted") {
      await fetchNotAccepted();
    } else if (filter === "Accepted") {
      await fetchAcceptedBatches();
    } else if (filter === "Completed") {
      await fetchCompletedBatches();
    }
  };

  // Handle the filter click to change the filter and fetch data
  const handleFilterClick = (filter) => {
    setSelectedFilter(filter);
    setActiveTable(filter);

    // Trigger the API call to fetch updated data based on the selected filter
    fetchDataBasedOnFilter(filter);
  };

  const fetchAllJobsBasedOnCampaignId = async () => {
    try {
      setAllJobsBasedLoading(true);
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("Token not found in localStorage");
        return;
      }

      const response = await axios.get(
        `${process.env.REACT_APP_URL}/jobs/allAvailableJobsForInstallation?campaignId=${id}&serviceType=1`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response?.data?.success && Array.isArray(response.data.data)) {
        const allJobs = response.data.data;
        setForBatch(allJobs);

        const filteredJobs = allJobs.filter(
          (job) =>
            !job.batchOfJobsForInstallationPartnerId && job.serviceType === "1",
        );

        setAvailableJobs(filteredJobs); // render all jobs
      } else {
        console.warn("Unexpected API response", response);
        setAvailableJobs([]);
      }
    } catch (error) {
      console.error("Error while fetching jobs", error);
      setAvailableJobs([]);
      setSnackbar({
        open: true,
        message: "Error fetching available jobs",
        severity: "error",
      });
    } finally {
      setAllJobsBasedLoading(false);
    }
  };

  const fetchAllBatchesBasedOnCampaignId = async () => {
    setAllBatchesLoading(true);
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/Jobs/allBatchesForInstallation?campaignId=${id}&serviceType=1`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (response?.data?.success) {
        const AllBatchesInInstallation = response.data.data.filter(
          (batch) => batch.serviceType == "1",
        );
        setAvailableBatches(AllBatchesInInstallation);

        // // Update accepted batches
        // const filteredAcceptedBatches = AllBatchesInInstallation.filter(
        //   (batch) => batch.installationPartnerId
        // );
        // setAcceptedBatches(filteredAcceptedBatches);

        // Update not accepted batches
        // const notAcceptedBatches = AllBatchesInInstallation.filter(
        //   (batch) => !batch.installationPartnerId
        // );
        // setIsNotAccepted(notAcceptedBatches);

        // const allPublished = AllBatchesInInstallation.every(
        //   (batch) => batch.isPublished == true
        // );
        // setAllPublish(allPublished);
        setTotalBatches(AllBatchesInInstallation.length);
        setSelectedBatchIds([]);
      }
    } catch (error) {
      console.error("Error while fetching batches", error);
      setSnackbar({
        open: true,
        message: "Error fetching batches",
        severity: "error",
      });
    } finally {
      setAllBatchesLoading(false);
    }
  };

  const fetchNotAccepted = async () => {
    setAllBatchesLoading(true);
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/Jobs/unacceptedBatchesForInstallation?campaignId=${id}&serviceType=1`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (response?.data?.success) {
        setIsNotAccepted(response.data.data);
        setTotalNotAcceptedBatches(response.data.data.length);
      }
    } catch (error) {
      console.error("Error while fetching batches", error);
      setSnackbar({
        open: true,
        message: "Error fetching batches",
        severity: "error",
      });
    } finally {
      setAllBatchesLoading(false);
    }
  };

  const fetchIncompleteBatches = async () => {
    setAllBatchesLoading(true);
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/Jobs/incompleteBatchesForInstallation?campaignId=${id}&serviceType=1`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response?.data?.success) {
        const allIncompleteBatches = response.data.data;

        // Process batches here (previously in useEffect)
        const updatedBatches = allIncompleteBatches.map((batch) => {
          if (batch?.jobs?.length > 0) {
            const jobDates = batch.jobs.map(
              (job) => new Date(job.jobStartingDate),
            );
            const completionDates = batch.jobs.map(
              (job) => new Date(job.jobCompletionDate),
            );

            const earliestDate = new Date(
              Math.min(...jobDates.map((date) => date.getTime())),
            );
            const latestDate = new Date(
              Math.max(...completionDates.map((date) => date.getTime())),
            );

            batch.dateRange = `${earliestDate.toLocaleDateString()} - ${latestDate.toLocaleDateString()}`;
            batch.totalPayment = batch.jobs.reduce(
              (sum, job) => sum + (job.paymentAmount || 0),
              0,
            );
          } else {
            batch.dateRange = "No Dates Available";
            batch.totalPayment = 0;
          }
          return batch;
        });

        setIncompleteBatches(updatedBatches);

        setTotalIncompleteBatches(updatedBatches.length);
      }
    } catch (error) {
      console.error("Error while fetching incomplete batches", error);
      setSnackbar({
        open: true,
        message: "Error fetching incomplete batches",
        severity: "error",
      });
    } finally {
      setAllBatchesLoading(false);
    }
  };

  // Fetch accepted batches for the "Accepted" filter
  const fetchAcceptedBatches = async () => {
    setAllBatchesLoading(true);
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/Jobs/acceptedBatchesForInstallation?campaignId=${id}&serviceType=1`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response?.data?.success) {
        const allBatches = response.data.data;

        // Filter for Accepted batches
        const filteredAcceptedBatches = allBatches.filter(
          (batch) => batch.installationPartnerId && batch.serviceType == "1",
        );
        setAcceptedBatches(filteredAcceptedBatches);
        setTotalAcceptedBatches(filteredAcceptedBatches.length);
      }
    } catch (error) {
      console.error("Error while fetching accepted batches", error);
      setSnackbar({
        open: true,
        message: "Error fetching batch status",
        severity: "error",
      });
    } finally {
      setAllBatchesLoading(false);
    }
  };

  //fetch completed batches for installation
  const fetchCompletedBatches = async () => {
    setAllBatchesLoading(true);
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/Jobs/completedBatchesForInstallation?campaignId=${id}&serviceType=1`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response?.data?.success) {
        const allBatches = response.data.data;
        setCompletedBatches(allBatches);
        setTotalCompletedBatches(allBatches.length);
      }
    } catch (error) {
      console.error("Error while fetching completed batches", error);
      setSnackbar({
        open: true,
        message: "Error fetching batch status",
        severity: "error",
      });
    } finally {
      setAllBatchesLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchDataBasedOnFilter(selectedFilter);
    }
  }, [id, selectedFilter]);

  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleActionClick = async (action) => {
    if (action === "Create Batches") {
      setOpenModalToCreateJobBatches(true);
    }
    if (action === "Publish All Batch") {
      if (selectedBatchIds.length === 0) {
        setSnackbar({
          open: true,
          message: "Please select at least one batch to publish",
          severity: "error",
        });
        return;
      }

      try {
        setIsPublishDisabled(true);
        const token = localStorage.getItem("token");
        const responseFromSaving = await axios.post(
          `${process.env.REACT_APP_URL}/batchOfJobs/publishBatches`,
          {
            batchIds: selectedBatchIds,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        if (responseFromSaving?.data.success) {
          setIsPublishDisabled(false);
          fetchAllBatchesBasedOnCampaignId();
          setSelectedBatchIds([]);
          setSnackbar({
            open: true,
            message: `${responseFromSaving.data.message}`,
            severity: "success",
          });
        }
      } catch (error) {
        setIsPublishDisabled(false);
        console.error("Error while publishing batches", error);
        setSnackbar({
          open: true,
          message: "Error publishing batches",
          severity: "error",
        });
      }
    }
  };

  const filteredActions = actions.filter((action) => {
    if (
      selectedFilter === "Available Jobs" &&
      action === "Publish All Batches"
    ) {
      return false;
    }
    if (selectedFilter === "Not Accepted" && action === "Create Batches") {
      return false;
    }
    if (selectedFilter === "All Batches" && action !== "Publish All Batches") {
      return false;
    }
    return true;
  });

  return (
    <div>
      {/* Divider */}
      <Divider sx={{ marginBottom: "1rem" }} />

      {/* Filters and Actions Container */}
      <div
        className="flex flex-wrap justify-between items-center gap-4"
        style={{
          display: "flex",
          flexWrap: "wrap",
          marginBottom: "1rem",
          marginLeft: "1rem",
          marginRight: "1rem",
        }}
      >
        {/* Filters and Actions Container */}

        {/* Left Section: Filters */}
        <div
          className="filters-section"
          style={{ flex: 1, display: "flex", gap: "8px", flexWrap: "wrap" }}
        >
          {filters.map((filter) => (
            <Button
              variant="outlined"
              key={filter}
              sx={{
                fontSize: "0.8rem",
                textTransform: "none",
                borderRadius: "8px",
                padding: "4px 12px",
                color: selectedFilter === filter ? "white" : "black",
                borderColor:
                  selectedFilter === filter ? "transparent" : "#d9dadb",
                backgroundColor:
                  selectedFilter === filter ? "black" : "transparent",
                "&:hover": {
                  backgroundColor:
                    selectedFilter === filter ? "black" : "transparent",
                  borderColor:
                    selectedFilter === filter ? "transparent" : "#d9dadb",
                },
              }}
              onClick={() => handleFilterClick(filter)}
            >
              {filter}
            </Button>
          ))}
        </div>

        {/* Right Section: Total Jobs Count + Create Batches */}
        <Box display="flex" alignItems="center" gap={2}>
          {selectedFilter === "Available Jobs" && (
            <Chip
              label={`Total Jobs Available: ${availableJobs.length}`}
              sx={{
                fontSize: "0.8rem",
                fontWeight: "400",
                padding: "6px 12px",
                backgroundColor: "transparent",
                border: "1px solid #d9dadb",
                color: "black",
              }}
            />
          )}
          {selectedFilter === "All Batches" && (
            <Chip
              label={`Total Batches: ${totalBatches}`}
              sx={{
                fontSize: "0.8rem",
                fontWeight: "400",
                padding: "6px 12px",
                backgroundColor: "transparent",
                border: "1px solid #d9dadb",
                color: "black",
              }}
            />
          )}
          {selectedFilter === "Completed" && (
            <Chip
              label={`Total Completed Batches: ${totalCompletedBatches}`}
              sx={{
                fontSize: "0.8rem",
                fontWeight: "400",
                padding: "6px 12px",
                backgroundColor: "transparent",
                border: "1px solid #d9dadb",
                color: "black",
              }}
            />
          )}
          {selectedFilter === "Accepted" && (
            <Chip
              label={`Total Accepted Batches: ${totalAcceptedBatches}`}
              sx={{
                fontSize: "0.8rem",
                fontWeight: "400",
                padding: "6px 12px",
                backgroundColor: "transparent",
                border: "1px solid #d9dadb",
                color: "black",
              }}
            />
          )}
          {selectedFilter === "Not Accepted" && (
            <Chip
              label={`Total Not Accepted Batches: ${totalNotAcceptedBatches}`}
              sx={{
                fontSize: "0.8rem",
                fontWeight: "400",
                padding: "6px 12px",
                backgroundColor: "transparent",
                border: "1px solid #d9dadb",
                color: "black",
              }}
            />
          )}
          {selectedFilter === "Incomplete" && (
            <Chip
              label={`Total Incomplete Batches: ${totalIncompleteBatches}`}
              sx={{
                fontSize: "0.8rem",
                fontWeight: "400",
                padding: "6px 12px",
                backgroundColor: "transparent",
                border: "1px solid #d9dadb",
                color: "black",
              }}
            />
          )}

          {/* Create Batches Button */}
          {selectedFilter === "Available Jobs" && (
            <Button
              key="Create Batches"
              variant="outlined"
              disabled={
                isDisabled === "Installation" ||
                selectedFilter !== "Available Jobs" ||
                availableJobs.length === 0
              }
              sx={{
                fontSize: "0.8rem",
                textTransform: "none",
                borderRadius: "8px",
                padding: "4px 12px",
                color:
                  isDisabled === "Installation" || availableJobs.length === 0
                    ? "black"
                    : "#418cff",
                borderColor: "#418cff",
                backgroundColor:
                  isDisabled === "Installation" || availableJobs.length === 0
                    ? "#d9dadb"
                    : "transparent",
                "&:hover": {
                  backgroundColor:
                    isDisabled === "Installation" || availableJobs.length === 0
                      ? "#d9dadb"
                      : "rgba(65, 140, 255, 0.1)",
                },
                "&.Mui-disabled": {
                  backgroundColor: "#d9dadb",
                  color: "black",
                  borderColor: "#d9dadb",
                },
              }}
              onClick={() => {
                if (selectedJobs.length === 0) {
                  setSnackbar({
                    open: true,
                    message: "Please select at least one job to create a batch",
                    severity: "error",
                  });
                  return;
                }
                handleActionClick("Create Batches");
              }}
            >
              Create Batches
            </Button>
          )}
          {selectedFilter === "All Batches" && (
            <Button
              key="Publish All Batch"
              variant="outlined"
              disabled={allPublish}
              sx={{
                fontSize: "0.8rem",
                textTransform: "none",
                borderRadius: "8px",
                padding: "4px 12px",
                color: "#418cff",
                borderColor: "#418cff",
                backgroundColor: "transparent",
              }}
              onClick={() =>
                isPublishDisabled
                  ? null
                  : handleActionClick("Publish All Batch")
              }
            >
              {isPublishDisabled ? "Publish All Batch..." : "Publish All Batch"}
            </Button>
          )}
        </Box>
      </div>

      {/* Dynamic Table Rendering */}
      <Box sx={{ marginTop: "1rem" }}>
        {activeTable === "Available Jobs" && (
          <AvailableJob
            setAvailableJobs={setAvailableJobs}
            setSelectedJobs={setSelectedJobs}
            selectedJobs={selectedJobs}
            selectAll={selectAll}
            setSelectAll={setSelectAll}
            allJobsBasedLoading={allJobsBasedLoading}
            availableJobs={availableJobs}
            updateJobInParent={(updatedJob) => {
              const updatedJobs = availableJobs.map((job) =>
                job._id === updatedJob._id ? updatedJob : job,
              );
              setAvailableJobs(updatedJobs);
            }}
            campaignData={campaignData}
          />
        )}
        {activeTable === "All Batches" && (
          <AllBatch
            availableBatches={availableBatches}
            setAvailableBatches={setAvailableBatches}
            availableJobs={forbatch}
            updateJobInParent={(updatedJob) => {
              const updatedJobs = forbatch.map((job) =>
                job._id === updatedJob._id ? updatedJob : job,
              );
              setForBatch(updatedJobs);
            }}
            isAllBatchesLoading={isAllBatchesLoading}
            selectedBatchIds={selectedBatchIds}
            setSelectedBatchIds={setSelectedBatchIds}
            fetchAllJobsBasedOnCampaignId={fetchAllJobsBasedOnCampaignId}
            fetchAllBatchesBasedOnCampaignId={fetchAllBatchesBasedOnCampaignId}
            setOpenModalToUpdateBatch={setOpenModalToUpdateBatch}
            setSelectedBatch={setSelectedBatch}
            campaignData={campaignData}
          />
        )}
        {activeTable === "Incomplete" && (
          <Incomplete
            setIncompleteBatches={setIncompleteBatches}
            incompleteBatches={incompleteBatches}
            isAllBatchesLoading={isAllBatchesLoading}
            setAvailableBatches={setAvailableBatches}
            acceptedBatches={acceptedBatches}
            setAcceptedBatches={setAcceptedBatches}
            forbatch={forbatch}
            setTotalIncompleteBatches={setTotalIncompleteBatches}
            fetchAllJobsBasedOnCampaignId={fetchAllJobsBasedOnCampaignId}
            fetchAllBatchesBasedOnCampaignId={fetchAllBatchesBasedOnCampaignId}
            campaignData={campaignData}
          />
        )}
        {activeTable === "Not Accepted" && (
          <NotAccepted
            isAllBatchesLoading={isAllBatchesLoading}
            setAvailableBatches={setAvailableBatches}
            isNotAccepted={isNotAccepted}
            setAcceptedBatches={setAcceptedBatches}
            matchingJobs={forbatch}
            setTotalNotAcceptedBatches={setTotalNotAcceptedBatches}
            fetchAllJobsBasedOnCampaignId={fetchAllJobsBasedOnCampaignId}
            fetchAllBatchesBasedOnCampaignId={fetchAllBatchesBasedOnCampaignId}
            setIsNotAccepted={setIsNotAccepted}
            campaignData={campaignData}
          />
        )}
        {/* {activeTable === "Accepted" && <Accepted />} */}
        {activeTable === "Accepted" && (
          <Accepted
            isAllBatchesLoading={isAllBatchesLoading}
            setAvailableBatches={setAvailableBatches}
            acceptedBatches={acceptedBatches}
            setAcceptedBatches={setAcceptedBatches}
            forbatch={forbatch}
            fetchAcceptedBatches={fetchAcceptedBatches}
            setTotalAcceptedBatches={setTotalAcceptedBatches}
            fetchAllJobsBasedOnCampaignId={fetchAllJobsBasedOnCampaignId}
            fetchAllBatchesBasedOnCampaignId={fetchAllBatchesBasedOnCampaignId}
            campaignData={campaignData}
          />
        )}
        {/* {activeTable === "Completed" && <Completed />} */}
        {/* {activeTable === "Completed" && (
          <Completed
            completedBatches={completedBatches}
            setCompletedBatches={setCompletedBatches}
          /> 
        )}*/}
        {activeTable === "Completed" && (
          <Completed
            completedBatches={completedBatches}
            setCompletedBatches={setCompletedBatches}
            totalCompletedBatches={totalCompletedBatches}
            isAllBatchesLoading={isAllBatchesLoading}
            acceptedBatches={acceptedBatches}
            setAcceptedBatches={setAcceptedBatches}
            forbatch={forbatch}
            fetchAllJobsBasedOnCampaignId={fetchAllJobsBasedOnCampaignId}
            setTotalCompletedBatches={setTotalCompletedBatches} // Pass setTotalCompletedBatches function
            campaignData={campaignData}
          />
        )}

        {openModalToCreateJobBatches && (
          <ModalToCreateJobBatches
            serviceTypeDynamic={serviceType}
            openModalToCreateJobBatches={openModalToCreateJobBatches}
            setOpenModalToCreateJobBatches={setOpenModalToCreateJobBatches}
            campaignData={id}
            availableJobs={availableJobs}
            setSelectedJobs={setSelectedJobs}
            selectedJobs={selectedJobs}
            fetchAllJobsBasedOnCampaignId={fetchAllJobsBasedOnCampaignId}
            serviceName={serviceName}
            setSnackbar={setSnackbar}
            setIsNotAccepted={setIsNotAccepted}
          />
        )}

        <Snackbar
          open={snackbar.open}
          autoHideDuration={5000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert
            onClose={handleSnackbarClose}
            severity={snackbar.severity}
            icon={
              snackbar.severity === "success" ? (
                <CheckCircleIcon sx={{ color: "white" }} />
              ) : (
                <ErrorIcon sx={{ color: "white" }} />
              )
            }
            sx={{
              backgroundColor:
                snackbar.severity === "success" ? "green" : "red",
              color: "white",
              display: "flex",
              alignItems: "center",
            }}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
      </Box>
    </div>
  );
};

export default JobsActionPanel;
